import { getMe } from 'core/API/broadcast';
import { SecurityRoleResponse } from 'core/API/securityRoles';

export function mapMeSecurityRoleToResponse(securityRole: any): SecurityRoleResponse {
	return {
		...securityRole,
		id: Number(securityRole['@id']?.split('/').pop() ?? 0),
		'@id': securityRole['@id'] ?? '',
		createdAt: securityRole.createdAt ?? '',
		createdBy: securityRole.createdBy ?? '',
		deleted: securityRole.deleted ?? false,
		identifier: securityRole.identifier ?? '',
		name: securityRole.name ?? '',
		securityRolePermission: securityRole.securityRolePermission ?? [],
		updatedAt: securityRole.updatedAt ?? '',
		updatedBy: securityRole.updatedBy ?? '',
		workplace: securityRole.workplace ?? '',
		securityRoleType: securityRole.securityRoleType,
	};
}

/**
 * Fetches the logged-in user's latest security role from /users/me
 * and persists it to localStorage.
 */
export async function fetchCurrentUserRoleFromMe(): Promise<SecurityRoleResponse | null> {
	const me = await getMe();

	const storedData = localStorage.getItem('BYOD-app');
	if (storedData) {
		try {
			const parsedData = JSON.parse(storedData);
			parsedData.user = me;
			localStorage.setItem('BYOD-app', JSON.stringify(parsedData));
		} catch (error) {
			console.error('Failed to update user data in localStorage:', error);
		}
	}

	if (!me?.securityRole) return null;
	return mapMeSecurityRoleToResponse(me.securityRole);
}
